import { IMSubscriptionPlan } from '@/types';

export function filterIMPlans(
  plansArray: IMSubscriptionPlan[] | null | undefined,
  period: string,
  currentPlanId?: string
): IMSubscriptionPlan[] {
  if (!plansArray) return [];

  return plansArray
    .filter((plan: IMSubscriptionPlan) => (
      plan.period === period &&
      plan.id !== currentPlanId
    ))
    .sort((a: IMSubscriptionPlan, b: IMSubscriptionPlan) => a.flatFee - b.flatFee);
}

export function getIMMonthlyEquivalent(
  yearlyPlan: IMSubscriptionPlan,
  plans: IMSubscriptionPlan[] | null | undefined
): IMSubscriptionPlan | null {
  if (yearlyPlan.period !== 'year' || !plans) return null;

  return plans.find((plan: IMSubscriptionPlan) =>
    plan.period === 'month' &&
    plan.name === yearlyPlan.name
  ) || null;
}

export function getIMYearlyEquivalent(
  monthlyPlan: IMSubscriptionPlan,
  plans: IMSubscriptionPlan[] | null | undefined
): IMSubscriptionPlan | null {
  if (monthlyPlan.period !== 'month' || !plans) return null;

  return plans.find((plan: IMSubscriptionPlan) =>
    plan.period === 'year' &&
    plan.name === monthlyPlan.name
  ) || null;
}

export function navigateToSelectedPlan (plan: IMSubscriptionPlan | null, filteredPlans: IMSubscriptionPlan[], sliderRef: { [key: string]: any }, sliderSettings: { [key: string]: any }) {
  if (!plan || !sliderRef.current) return;

  // Find the index of the plan in the filtered plans
  const planIndex = filteredPlans.findIndex((p: IMSubscriptionPlan) => p.id === plan.id);
  if (planIndex === -1) return;

  // Calculate which slide to go to based on the slidesToShow setting
  // For example, if slidesToShow is 3, then we want to show slides in groups of 3
  const slidesToShow = sliderSettings.slidesToShow;
  const slideToGoTo = Math.floor(planIndex / slidesToShow) * slidesToShow;

  setTimeout(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(slideToGoTo);
    }
  }, 100); // Small delay to ensure the slider has updated with new plans
};
